export default __webpack_public_path__ + "static/media/user1.78cff169.png";